<h2 mat-dialog-title>
  @if (isEdit) {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
    Rediger fejl
  } @else {
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#plus-s"></use></svg>
    Anmeld fejl
  }
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>

<form [formGroup]="form" (ngSubmit)="submitForm()">
  <mat-dialog-content>
    <div class="form-row">
      <mat-form-field color="accent">
        <mat-label>Lokation</mat-label>
        <input
          type="text"
          matInput
          formControlName="location"
          [matAutocomplete]="auto"
          placeholder="Påbegynd indtastning (min. 2 karakterer)" />
        <mat-autocomplete #auto="matAutocomplete" #matAutocomplete [displayWith]="displayLocation" okCustomDropDownArrowDirective>
          @for (option of filteredOptions; track option) {
            <mat-option
              [value]="option"
              matTooltip="{{ option.name }}, {{ option.road }} {{ option.number }}{{ option.letter }}, {{ option.postalCode }} {{
                option.city
              }}">
              {{ option.name }}, {{ option.road }} {{ option.number }}{{ option.letter }}, {{ option.postalCode }} {{ option.city }}
            </mat-option>
          }
        </mat-autocomplete>
        <mat-icon matSuffix></mat-icon>
        @if (location.invalid && (location.dirty || location.touched)) {
          <mat-error>
            <div>Lokation skal vælges fra listen</div>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Ladepunkt</mat-label>
        <mat-select formControlName="connectorIdentifier" name="selectedConnector" okCustomDropDownArrowDirective>
          @for (connector of connectors; track connector) {
            <mat-option [value]="connector.connectorIdentifier">
              {{ connector.stationNumber }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
        @if (connectorIdentifier.invalid && (connectorIdentifier.dirty || connectorIdentifier.touched)) {
          <mat-error>
            <div>Ladepunkt skal vælges fra listen</div>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field>
        <mat-label>Kategori</mat-label>
        <mat-select formControlName="category" name="selectedCategory" okCustomDropDownArrowDirective>
          @for (category of categories | enumToArray | translateIncidentCategoryEnum; track category) {
            <mat-option [value]="category.index">
              {{ category.name }}
            </mat-option>
          }
        </mat-select>
        <mat-icon matSuffix></mat-icon>
        @if (category.invalid && (category.dirty || category.touched)) {
          <mat-error>
            <div>Kategori skal vælges fra listen</div>
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-row">
      <mat-form-field class="mdc-textarea-fix">
        <mat-label>Beskrivelse</mat-label>
        <textarea formControlName="description" matInput rows="5"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    @if (isEdit) {
      <div class="unit-identifier">
        <span>ID:</span>
        {{ incident.number | formatIncident }}
      </div>
    }

    <button mat-dialog-close type="button" mat-button>Annuller</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid || !form.dirty">Gem</button>
  </mat-dialog-actions>
</form>
